import { OracleState } from './types';

export const oracleSearchInitialState: OracleState = {
  data: { userQuoteTokenByResponseID: {} },
  visual: {
    likeSet: new Set(),
    dislikeSet: new Set(),
    savedEqlTokenSet: new Set(),
  },
};
